import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadDecisionSummary = (documentId, siteId) =>
  get(`${url}/leasingDocument/${documentId}/${siteId}/decisionSummary`);
const loadContractGenPermissions = (documentId, siteId) =>
  get(`${url}/leasingOffers/${documentId}/${siteId}/ContractGenerationPermissions`);
const generateContract = (documentId, siteId) =>
  post(`${url}/leasingOffers/${documentId}/${siteId}/generateContract`, { documentId: documentId, siteId: siteId });

const exp = {
  loadDecisionSummary,
  loadContractGenPermissions,
  generateContract
};
export default exp;
